<template>
  <div>
    <div class="row mt_16"><div class="col create_title">規劃投資組合</div></div>
    <div class="d-flex mt_25">
      <div class="mr_3">
        <strong style="line-height: 40px">假設投資報酬率:</strong>
      </div>
      <div class="position-relative">
        <div class="notice-top text-red">
          第(1)欄需為3.0%~6.0%，第(2)欄需為0.1%~2.9%，第(4)欄需為第(1)欄之負值
        </div>
        <div class="d-flex">
          <!-- (1) 配合投商管二科調整報酬率順序，由高到低呈現(原欄位沿用) -->
          <div class="d-flex mr_10 align-items-center">
            <label>(1)</label>
            <input
              type="number"
              step="0.1"
              class="form-control mr_2 ml_2"
              style="width: 7rem"
              @input="floatHandler(productDataScope, 'ratio3')"
              v-model="productDataScope.ratio3"
              :class="{ 'is-invalid': errors.has(mainIndex + 'ratio3') }"
              :data-vv-name="mainIndex + 'ratio3'"
              data-vv-as="假設投資報酬率(1)"
              v-validate="`required|ratio3`"
            />%
          </div>
          <!-- (2)roi -->
          <div class="d-flex mr_10 align-items-center">
            <label>(2)</label>
            <input
              type="number"
              step="0.1"
              class="form-control mr_2 ml_2"
              style="width: 7rem"
              :class="{ 'is-invalid': errors.has(mainIndex + 'ratio2') }"
              @input="floatHandler(productDataScope, 'ratio2')"
              v-model="productDataScope.ratio2"
              :data-vv-name="mainIndex + 'ratio2'"
              data-vv-as="假設投資報酬率(2)"
              v-validate="`required|ratio2`"
            />%
          </div>
          <!-- (3) -->
          <div class="d-flex align-items-center mr_10">
            <label>(3)</label>
            <div style="line-height: 40px" class="ml_2">0%</div>
          </div>
          <!-- (4) -->
          <div class="d-flex align-items-center">
            <label>(4)</label>
            <input
              type="text"
              class="form-control ml_2"
              style="width: 7rem"
              v-model="productDataScope.ratio4"
              disabled
            />%
          </div>
        </div>
      </div>
    </div>
    <div class="mt_10">
      <div class="d-flex align-items-center">
        <button
          class="btn btn-primary ml_10"
          style="line-height: 20px; height: 44px"
          @click="
            toInvestmentTarget(
              'fund',
              '一般投資基金配置',
              PRODUCT_FEATURE_DATA.fund_lmt,
              'E5F6EC',
              '53c480',
              '非永續平台',
              true
            )
          "
        >
          選擇一般投資標的
        </button>
      </div>
      <InventmentTarget
        :selectInvestmentTargets="
          $store.getters.MfEditing.mc_prod_list[0].fund
            ? $store.getters.MfEditing.mc_prod_list[0].fund.fund
            : []
        "
        name="一般投資基金配置"
        propName="fund"
        :validTotal100Text="`投資比例需以${PRODUCT_FEATURE_DATA.fund_rato ||5}%為單位，且一般標的及額外指定標的投資比例分開計算，各自合計需為100%！ `"
        ref="InventmentTarget1"
      />
    </div>
    <div class="mt_10">
      <div class="d-flex align-items-center">
        <button
          class="btn btn-primary ml_10"
          style="line-height: 20px; height: 44px"
          @click="
            toInvestmentTarget(
              'fund_extra',
              '額外指定投資配置',
              PRODUCT_FEATURE_DATA.cho_fund_cnt,
              'E5F6EC',
              '53c480',
              '永續平台'
              ,true
            )
          "
        >
          選擇額外指定投資標的
        </button>
      </div>
      <InventmentTarget
        :selectInvestmentTargets="
          $store.getters.MfEditing.mc_prod_list[0].fund
            ? $store.getters.MfEditing.mc_prod_list[0].fund.fund_extra
            : []
        "
        name="額外指定投資配置"
        propName="fund_extra"
        color="E5F6EC"
        border="53c480"
        :validTotal100Text ="`投資比例需以${PRODUCT_FEATURE_DATA.fund_rate ||5}%為單位，且一般標的及額外指定標的投資比例分開計算，各自合計需為100%！`"
        ref="InventmentTarget2"
      />
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import InventmentTarget from "./InventmentTarget.vue";

import { Validator } from "vee-validate";
import _ from "lodash";
export default {
  props: ["productDataScope", "mainIndex"],
  components: { InventmentTarget },
  mixins: [mf_Mixin],
  created() {
    this.init();
    this.initValidator();
  },
  computed: {
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    PRODUCT_FEATURE_DATA() {
      return this.MfEditing.mc_prod_list[0].FEATURE_DATA;
    },
  },
  methods: {
    init() {
      this.productDataScope.ratio1 = "0";
    },
    initValidator() {
      Validator.extend(`ratio2`, {
        getMessage: "",
        validate: (value) => {
          return value >= 0.1 && value <= 2.9 && (value * 10) % 1 == 0;
        },
      });
      Validator.extend(`ratio3`, {
        getMessage: "",
        validate: (value) => {
          return value >= 3 && value <= 6 && (value * 10) % 1 == 0;
        },
      });
    },
    //選擇投資標的
    async toInvestmentTarget(
      propName = "fund",
      name = "基金配置",
      maxLength = 10,
      color = "E5F6EC",
      border = "53c480",
      fund_class = "",
      filterFundClass = false
    ) {
      let vaildRate = await this.$validator.validateAll(); //檢核標的
      if (vaildRate) {
        this.$router.push(
          `/mf/create/investmentTarget?propName=${propName}&name=${name}&maxLength=${maxLength}&color=${color}&border=${border}&fund_class=${fund_class}&filterFundClass=${filterFundClass}`
        );
      } else {
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤! ",
        });
      }
    },
    async validateAll() {
      //檢核上方輸入框與投資比例分配
      let VaildInput = await this.$validator.validateAll();
      let vaildInventment1 = await this.$refs[
        "InventmentTarget1"
      ].validateAll();
      let vaildInventment2 = await this.$refs[
        "InventmentTarget2"
      ].validateAll();
      if (!vaildInventment1 || !vaildInventment2) return false;

      return VaildInput && vaildInventment1 && vaildInventment2;
    },
  },
  watch: {
    "productDataScope.ratio3": {
      handler() {
        this.productDataScope.ratio4 = "";
        let ratio3 = this.productDataScope.ratio3;
        if (ratio3 >= 3 && ratio3 <= 6 && (ratio3 * 10) % 1 == 0) {
          this.productDataScope.ratio4 = "-" + this.productDataScope.ratio3;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style>
</style>
